import React, { useState } from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';

const PasswordValidation = ({ password }) => {

    const validations = {
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        number: /[0-9]/.test(password),
        specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        minLength: password.length >= 8,
    };

    const rules = [
        { label: 'un caractère miniscule', valid: validations.lowercase },
        { label: 'un caractère majuscule', valid: validations.uppercase },
        { label: 'un chiffre', valid: validations.number },
        { label: 'un caractère special', valid: validations.specialChar },
        { label: '8 caractère au minimum', valid: validations.minLength },
    ];

    return (
        <Box sx={{ maxWidth: 400 }} >
            <Stack spacing={2}>
                {rules.map((rule, index) => (
                    <Stack direction={'row'} key={index} spacing={1}>
                        {rule.valid ? (
                            <CheckCircleIcon sx={{ color: green[500] }} />
                        ) : (
                            <CancelIcon sx={{ color: red[500] }} />
                        )}
                        <Typography variant='body2'>{rule.label}</Typography>
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
};

export default PasswordValidation;
